import { Box, Card, Stack, Text, useMantineColorScheme, useMatches } from "@mantine/core";
import { useTranslation } from "react-i18next";

import betaIllustration from "../../../assets/illustrations/beta.svg";
import { TextSerif } from "../TextSerif";

import { global_settings } from "@/config";

export const EarlyAccessBlueBanner = () => {
  const { t } = useTranslation();

  const isMobile = useMatches({ base: true, md: false });

  /* Theme */
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const bgCard = isDark ? "#657ab6" : "#d0d8ef";

  const hexToRgba = (hex: string, alpha: number) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  if (!global_settings.enableBetaUIElements) return null;

  const height = isMobile ? "fit-content" : 155;
  const titleSize = isMobile ? "1.25em" : "1.75em";
  const title = isMobile
    ? t("feedback.beta.mobileEarlyAccessVersion")
    : t("feedback.beta.earlyAccessVersion");

  const descriptionSize = isMobile ? "0.75em" : "sm";
  const descriptionWidth = isMobile ? 300 : 500;
  const descriptionLineHeight = isMobile ? "sm" : "1.4em";

  const gradientBG = isMobile
    ? `linear-gradient(to right,
          #102E8E 0%,
          #1438afe1 70%,
          #102d8e82 100%,
          ${hexToRgba(bgCard, 0.7)} 100%
        ), url(${betaIllustration})`
    : /* Desktop */
      `linear-gradient(to right, 
          #102E8E 0%,
          #102d8ef7 40%,
          #102d8ee9 45%,
          ${hexToRgba(bgCard, 0.7)} 85%,
          ${hexToRgba(bgCard, 0.7)} 100%
        ), url(${betaIllustration})`;

  return (
    <Card
      w="100%"
      p="lg"
      h={height}
      style={{
        backgroundColor: bgCard,
        backgroundImage: gradientBG,
        backgroundRepeat: "no-repeat, no-repeat",
        backgroundPosition: isMobile ? "center center" : "center",
        backgroundSize: isMobile ? "cover, 600px" : "cover, 850px",
      }}
    >
      <Stack gap="sm" p="sm" style={{ position: "relative", zIndex: 1 }}>
        <Text component="h2" c="white" fz={titleSize} lh="1.25em" mb="sm">
          {title}
        </Text>

        <Box maw="100%" w={descriptionWidth}>
          <TextSerif
            component="p"
            fz={descriptionSize}
            fw={400}
            lh={descriptionLineHeight}
            c="white"
          >
            {t("feedback.beta.earlyAccessDescription")}
          </TextSerif>
        </Box>
      </Stack>
    </Card>
  );
};
